<template>
  <div id="app">
    <router-view />
    <el-dialog
      title="不提醒发货时长"
      :visible.sync="durationDialogVisible"
      width="350px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="text-align: center;">
        <el-select v-model="selectedDuration" placeholder="请选择不提醒的时长" style="width: 200px;">
          <el-option label="10分钟" :value="10" />
          <el-option label="30分钟" :value="30" />
          <el-option label="1小时" :value="60" />
          <el-option label="8小时" :value="480" />
          <el-option label="1天" :value="1440" />
          <el-option label="3天" :value="4320" />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDuration">返 回</el-button>
        <el-button type="primary" @click="confirmDuration">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUndeliveredList } from '@/api/yxStoreOrder'
import { getToken } from '@/utils/auth'

export default {
  name: 'App',
  data() {
    return {
      checkTimer: null,
      isPaused: false,
      pauseEndTime: null,
      currentOrderCount: 0,
      durationDialogVisible: false,
      selectedDuration: 10,
      STORAGE_KEY: 'order_reminder_pause'
    }
  },
  mounted() {
    // 从localStorage读取暂停时间
    const storedPauseEndTime = localStorage.getItem(this.STORAGE_KEY)
    if (storedPauseEndTime) {
      const endTime = parseInt(storedPauseEndTime)
      const now = new Date().getTime()
      if (now < endTime) {
        this.pauseEndTime = endTime
        this.isPaused = true
      } else {
        localStorage.removeItem(this.STORAGE_KEY)
      }
    }
    this.checkUndeliveredOrders()
    this.startTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    async checkUndeliveredOrders() {
      // 如果未登录，不请求接口
      if (!getToken()) {
        return
      }

      // 如果当前在订单页面，不请求接口
      if (this.$route.path === '/order/order') {
        return
      }

      if (this.isPaused && this.pauseEndTime) {
        const now = new Date().getTime()
        if (now < this.pauseEndTime) {
          return
        } else {
          this.isPaused = false
          this.pauseEndTime = null
        }
      }

      try {
        const res = await getUndeliveredList(0, 1000)
        if (res && res.content && res.content.length > 0) {
          this.currentOrderCount = res.content.length
          this.stopTimer()
          this.showNotification(res.content.length)
        }
      } catch (e) {
        console.error('检查待发货订单失败', e)
      }
    },

    showNotification(count) {
      const _this = this
      this.$msgbox({
        title: '发货提醒',
        message: `您有 <strong>${count}</strong> 个待发货订单，请及时处理！`,
        showCancelButton: true,
        confirmButtonText: '去处理',
        cancelButtonText: '暂不处理',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        _this.$router.push({ path: '/order/order', query: { status: '1' }})
        _this.startTimer()
      }).catch((action) => {
        if (action === 'cancel') {
          _this.showDurationSelector()
        }
      })
    },

    showDurationSelector() {
      this.selectedDuration = 10
      this.durationDialogVisible = true
    },

    confirmDuration() {
      if (this.selectedDuration) {
        this.setPauseDuration(this.selectedDuration)
      }
      this.durationDialogVisible = false
      this.startTimer()
    },

    cancelDuration() {
      this.durationDialogVisible = false
      // 重新显示发货提醒弹窗
      this.showNotification(this.currentOrderCount)
    },

    setPauseDuration(minutes) {
      const now = new Date().getTime()
      this.pauseEndTime = now + minutes * 60 * 1000
      this.isPaused = true
      localStorage.setItem(this.STORAGE_KEY, this.pauseEndTime)
      this.startTimer()
    },

    startTimer() {
      if (!this.checkTimer) {
        this.checkTimer = setInterval(() => {
          this.checkUndeliveredOrders()
        }, 30000)
      }
    },

    stopTimer() {
      if (this.checkTimer) {
        clearInterval(this.checkTimer)
        this.checkTimer = null
      }
    }
  }
}
</script>
